export default "__VITE_ASSET__1cd5e1c2__"